import { callProtectedApi } from '@/shared/api';

// ペイロードの型定義
interface UpdateMemberDepartmentsPayload {
  userId: string;
  deptIds: string[];
}

const UPDATE_ENDPOINT = 'update-member-departments';

/**
 * メンバーの所属部署を更新する
 * @param payload - 更新情報 { userId: string, deptIds: string[] }
 * @param token - Clerk認証トークン
 * @returns Promise<unknown> - API の返り値の型
 */
export async function updateMemberDepartments(
  payload: UpdateMemberDepartmentsPayload,
  token: string
): Promise<unknown> {
  try {
    console.log('API: Updating member departments:', payload);
    const response = await callProtectedApi<unknown>(UPDATE_ENDPOINT, {
      method: 'POST',
      body: payload as unknown as Record<string, unknown>,
      token,
    });
    console.log('API: Update member departments response:', response);
    return response;
  } catch (error) {
    console.error('API Error: updating member departments:', error);
    throw error;
  }
}
